import styled from 'styled-components';

export const OfferPreviewCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: rgb(247, 245, 246);
    border-radius: 6px;
    border: 1px solid #C6C6C6FF;
    gap: 16px;
    padding: 15px;
    width: 100%;
    max-width: 400px;
    margin: 5px 0;
    position: relative;
    overflow: hidden;
`;

export const OfferPreviewCardBadge = styled.div`
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    position: absolute;
    right: 25px;
    z-index: 2;
    top: 25px;
    background: #fff;
`;

export const OfferPreviewCardTitle = styled.h3`
    font-size: 18px;
    line-height: 1.5;
    font-weight: 500;
    color: rgb(50, 49, 49);
`;

export const OfferPreviewCardButton = styled.a`
    background-color: rgb(28, 28, 28);
    border-radius: 6px;
    border: none;
    cursor: pointer;
    padding: 15px;
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    color: white;
    font-size: 18px;
    font-weight: 500;
`;
